'use client';

import Container from '@mui/material/Container';
import {useTranslation} from 'react-i18next';
import type {Media} from '../../model';
import {FloorPlanViewer, MediaType} from '../gallery';
import {Section} from '../primitives';

export interface UnitFloorPlanSectionProps {
  floorPlans: Media[];
  onOpen: () => void;
}

export function UnitFloorPlanSection({floorPlans, onOpen}: UnitFloorPlanSectionProps) {
  const {t} = useTranslation();
  if (floorPlans.length === 0) {
    return null;
  }
  return (
    <Section>
      <Container>
        <FloorPlanViewer
          title={t('floor_plan')}
          images={floorPlans.map(media => ({type: MediaType.Image, src: media.src, alt: t('floor_plan')}))}
          onOpen={onOpen}
        />
      </Container>
    </Section>
  );
}

UnitFloorPlanSection.displayName = 'UnitFloorPlanSection';
